import React, { Component } from 'react';
import { resetMfaMethod } from 'services/CeberusApiService';
import { Form, Input, Button, Card, Typography } from 'antd';
import { PushNotification } from 'utils/PushNotification';
import { FormComponentProps } from 'antd/lib/form';

interface ResetMfaComponentState {
  loading: boolean;
}

class ResetMfaForm extends Component<FormComponentProps, ResetMfaComponentState> {
  state = {
    loading: false,
  };

  handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        this.setState({ loading: true });

        try {
          await resetMfaMethod({
            Mail: values.email,
            MetaData: undefined,
            BotIdentifier: '',
            ClusterName: ''
          });

          PushNotification.success(`The MFA method for user ${values.email} has been reset.`);
          this.props.form.resetFields();

        } catch (error) {
          const errorMessage = 'An unexpected error occurred. Please try again.';

          PushNotification.error(`Failed to Reset MFA: ${errorMessage}`);
        } finally {
          this.setState({ loading: false });
        }
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { loading } = this.state;

    return (
      <div style={{ padding: '24px', display: 'flex', justifyContent: 'center' }}>
        <Card
          title="Reset Multifactor Authentication (MFA)"
          style={{ maxWidth: 600, width: '100%' }}
        >
          <Typography.Paragraph type="secondary" style={{ marginBottom: '24px' }}>
            Insert the email of the user whose MFA method you want to reset. This action will remove the current MFA configuration,
            allowing the user to set it up again on their next login.
          </Typography.Paragraph>

          <Form layout="vertical" onSubmit={this.handleSubmit}>
            <Form.Item label="User Email">
              {getFieldDecorator('email', {
                rules: [
                  { required: true, message: 'Please enter an email.' },
                  { type: 'email', message: 'The email format is invalid.' }
                ],
              })(<Input placeholder="example@domain.com" />)}
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                block
              >
                Reset MFA
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    );
  }
}

export const ResetMfaComponent = Form.create<FormComponentProps>()(ResetMfaForm);
